<template>
  <div>
    <div v-for="(kategori, idKategori) in kategoris" :key="idKategori">
      <h2 class="black--text">{{ kategori.label }}</h2>
      <v-list>
        <v-list-item
          class="px-0"
          v-for="(partisipan, idPartisipan) in collection[kategori.key]"
          :key="`${idKategori}-${idPartisipan}`"
        >
          <v-list-item-content class="py-2">
            <v-row no-gutters style="flex-wrap: nowrap;">
              <v-col cols="1" class="flex-grow-0 flex-shrink-0" style="max-width: 25px">
                <span style="font-size: 17px">{{ idPartisipan + 1 }}.</span>
              </v-col>
              <v-col cols="11" style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0">
                <span style="font-size: 17px">{{ partisipan.nama }}</span>
                <div class="body-2"><span class="grey--text">NUPTK: </span>{{ partisipan.nuptk || '-' }}</div>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListPartisipan',
  props: {
    partisipans: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    collection() {
      return {
        sasaran: (this.partisipans || []).filter((partisipan) => +partisipan.is_pengajar !== 1),
        pengajar: (this.partisipans || []).filter((partisipan) => +partisipan.is_pengajar === 1),
      };
    },
  },
  data() {
    return {
      kategoris: [
        { key: 'sasaran', label: 'Sasaran IHT' },
        { key: 'pengajar', label: 'Pengajar IHT' },
      ],
    };
  },
};
</script>

<style scoped></style>
